import Title from '@components/common/Title'
import { useTranslation } from 'react-i18next'

const Billing = () => {
  const { t } = useTranslation()
  return <Title name={t('Financeiro')} />
}

export default Billing
